import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = [
  { id: 'fallback-1', name: 'Bow Ties', slug: 'bow-ties' },
  { id: 'fallback-2', name: 'Neckties', slug: 'neckties' },
];

export const useCategories = () => {
  const [categories, setCategories] = useState(FALLBACK);

  useEffect(() => {
    fetch(`${API_URL}/api/categories`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setCategories(data);
      })
      .catch(() => {});
  }, []);

  return categories;
};
